module.exports = __webpack_public_path__ + "static/media/after-sandy.4bb05b98.jpg";